import styled from "styled-components";

import boxContainerSrc from "assets/images/container.png";
import boxContainerHoverSrc from "assets/images/hover/container-hover.png";
import buysausageSrc from "assets/images/bubbleText/buysausage.png";

export const ImgWrapper = styled.div<{ ishovering?: boolean }>`
  position: absolute;
  display: block;
  width: 20%;
  height: 24%;
  left: 9rem;
  top: 10.2rem;

  background-image: url(${boxContainerSrc});
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;

  :hover {
    background-image: url(${boxContainerHoverSrc});
    ::after {
      position: absolute;
      background-image: url(${buysausageSrc});
      background-size: contain;
      display: inline-block;
      width: 100%;
      height: 51%;
      content: "";
      background-repeat: no-repeat;
      top: 0;
      right: 0;
      transform: translate(95%, 75%);
    }
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
      left: 19vw;
      top: 21.4vw;
  `}
`;
